import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type PostParams = {
  title: string;
  provider_name?: string | null;
  provider_id?: string | null;
  position: number;
};

export function usePostPendingItem(subjectId: string) {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async ({ title, provider_name, provider_id, position }: PostParams) => {
      const { data, error } = await apiClient
        .from('subject_pending_items')
        .insert({
          subject_id: subjectId,
          title,
          provider_name: provider_name ?? null,
          provider_id: provider_id ?? null,
          state: 'pending',
          position,
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getPendingItems(subjectId) });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.pendingSubTopics(currentSpace.id) });
        queryClient.invalidateQueries({ queryKey: keys.openPendingItems(currentSpace.id) });
      }
    },
  });
}
